module.exports = __webpack_public_path__ + "img/banner24-2.6cc87b73.jpg";